module.exports = __webpack_public_path__ + "img/light.cc45dccf.png";